import { useRouter } from '@tanstack/react-router';
import { createContext, use } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { jobsQueryFragment$key } from './__generated__/jobsQueryFragment.graphql';

export const JobsQueryCtx = createContext<jobsQueryFragment$key | null | undefined>(null);

const jobsQueryFragment = graphql`
    fragment jobsQueryFragment on QuartzJobSummaryPage {
        content {
            name
            group
            jobClass
            description
            durable
            requestsRecovery
            jobData
            triggers {
                name
                group
                type
                state
                previousFireTime
                nextFireTime
                priority
                misfireInstruction
                cronExpression
                timeZoneId
            }
            aggregateState
        }

        pageInfo {
            ...listPaginationQueryFragment
        }
    }
`;

export const useJobsQueryFragment = () => useFragment(jobsQueryFragment, use(JobsQueryCtx));

export const useJobsQueryFragmentRef = (fragmentRef?: jobsQueryFragment$key) =>
    useFragment(jobsQueryFragment, fragmentRef);

export const useJobsQueryRefresh = (): (() => void) => {
    const router = useRouter();
    return () => {
        router.invalidate();
    };
};
